import common from "./pages/common";
import home from "./pages/home";
import agents from "./pages/agents";
import chat from "./pages/chat";
import users from "./pages/users";
import login from "./pages/login";
import forgetPass from "./pages/forgetPass";
import oneTime from "./pages/oneTime";

const sections = {
  COMMON: common,
  HOME: home,
  AGENSTS: agents,
  CHAT: chat,
  USERS: users,
  LOGIN: login,
  FORGET_PASS: forgetPass,
  ONE_TIME: oneTime,
};

export default sections;
